import BreakfastCerealProduct from 'models/BreakfastCerealProduct'

export const packagingInitialState = {
  category: BreakfastCerealProduct.category,
  subCategory: BreakfastCerealProduct.subCategory,
  Kcals: BreakfastCerealProduct.Kcals,
  Folate: BreakfastCerealProduct.Folate,
  Fiber: BreakfastCerealProduct.Fiber,
  WholeGrainCert: BreakfastCerealProduct.WholeGrainCert,
  Iron: BreakfastCerealProduct.Iron,
  Sucrose: BreakfastCerealProduct.Sucrose,
  Rounding: BreakfastCerealProduct.Rounding,
  UnderIronLimit: BreakfastCerealProduct.UnderIronLimit,
  UnderSucroseLimit: BreakfastCerealProduct.UnderSucroseLimit,
  ContainsNoSweeteners: BreakfastCerealProduct.ContainsNoSweeteners,
  Size: BreakfastCerealProduct.Size,
}
